export default "__VITE_ASSET__5d1674b1__"